var r=function(r,n){return"string"==typeof r?r:r(n.baseCdnUrl)};export{r as getCdnUrl};
